import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import * as authActions from '@auth/store/auth.actions';

import { ListEntry } from './../list-entry';
import * as DataActions from './data.actions';

export interface ListState extends EntityState<ListEntry> {}
export const listAdapter: EntityAdapter<ListEntry> = createEntityAdapter<ListEntry>();

export interface CustListState extends EntityState<ListEntry> {}
export const custListAdapter: EntityAdapter<ListEntry> = createEntityAdapter<ListEntry>();

export interface DataState {
  lists: ListState;
  custLists: CustListState;
}

export const initialState: DataState = {
  lists: listAdapter.getInitialState(),
  custLists: custListAdapter.getInitialState(),
};

export function dataReducer(state = initialState, action: DataActions.DataActions) {
  switch (action.type) {
    case DataActions.API_STORE_LIST:
      return {
        ...state,
        lists: listAdapter.addOne(action.listEntry, state.lists),
      };
    case DataActions.API_STORE_CUST_LIST:
      return {
        ...state,
        custLists: custListAdapter.addOne(action.listEntry, state.custLists),
      };
    case DataActions.API_CLEAR_CUST_LISTS:
    case authActions.CHANGE_CUSTOMER:
      return {
        ...state,
        custLists: custListAdapter.getInitialState(),
      };
    default:
      return state;
  }
}
